import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { LogService } from './log/log.service';

@Injectable({
	providedIn: 'root'
})
export class GenericCrudService {
	constructor(private http: HttpClient, private logger: LogService) {}

	// Generic method to get data from APIs
	genericGetAPIData<T>(
		apiUrl: string,
		operation?: string,
		options?
	): Observable<any> {
		return this.http.get<T>(apiUrl, options).pipe(
			tap((_) => operation && this.logger.log(`Success: ${operation}`)),
			catchError(this.errorHandler<any>(operation))
		);
	}

	// Generic method to get data from APIs
	genericPostDataToAPI<T>(
		apiUrl: string,
		operation: string,
		payload?,
		options?
	): Observable<any> {
		return this.http.post<T>(apiUrl, payload, options).pipe(
			tap((_) => this.logger.log(`Success: ${operation}`)),
			catchError(this.errorHandler<any>(operation))
		);

	}

	// Generic method to get data from APIs
	genericPutDataToAPI<T>(
		apiUrl: string,
		operation: string,
		payload?,
		options?
	): Observable<any> {
		return this.http.put<T>(apiUrl, payload, options).pipe(
			tap((_) => this.logger.log(`Success: ${operation}`)),
			catchError(this.errorHandler<any>(operation))
		);
	}

	// Generic method to get data from APIs
	genericPatchDataToAPI<T>(
		apiUrl: string,
		operation: string,
		payload?,
		options?
	): Observable<any> {
		return this.http.patch<T>(apiUrl, payload, options).pipe(
			tap((_) => this.logger.log(`Success: ${operation}`)),
			catchError(this.errorHandler<any>(operation))
		);
	}

	// Generic method to get data from APIs
	genericDeleteAPIDataByID<T>(
		apiUrl: string,
		operation: string,
		options?
	): Observable<any> {
		return this.http.delete<T>(apiUrl, options).pipe(
			tap((_) => this.logger.log(`Success: ${operation}`)),
			catchError(this.errorHandler<any>(operation))
		);
	}

	errorHandler<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {
			this.logger.log(error);
			this.logger.log(`${operation} failed: ${error.message}`);

			return throwError(() => (result ? result : (error as T)));
		};
	}
}
